import { useEffect, useState } from 'react';
import { TextField, Button, Grid, Typography, Paper } from '@mui/material';
import { apiForgot } from '../../services/forgot/Forgot';
import '../login/loginComponent.css';
import './forgotComponent.css';

const ForgotComponent = () => {
    const [email, setEmail] = useState('');
    const [validationMessage, setValidationMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        document.body.classList.add('login-route');

        return () => {
            document.body.classList.remove('login-route');
        };
    }, []);

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!isLoading) {
            setIsLoading(true);
            let result = await apiForgot.post({ login: email });

            if (result.error) {
                setIsLoading(false);
                setValidationMessage(result.error);
            }

            setIsLoading(false);
            setValidationMessage(
                'Email z adresem do resetu hasla zostal wyslany na wskazany adres email',
            );
        }

        setEmail('');
    };

    return (
        <div className="home-container login-page forgot-page">
            <br />
            <br />
            <div className="home-hero">
                <Grid
                    container
                    justifyContent="center"
                    className="padding-body-2"
                >
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={0}
                            variant="outlined"
                            square={false}
                            className="login-paper forgot-paper"
                        >
                            <form onSubmit={handleSubmit}>
                                <div className="login-figma-hero">
                                    <div className="login-welcome">
                                        Witaj w aplikacji
                                    </div>
                                    <div className="login-brand">
                                        Agema<span>HOME</span>
                                    </div>
                                    <div className="login-avatar">
                                        <div className="login-avatar-head"></div>
                                        <div className="login-avatar-body"></div>
                                    </div>
                                </div>

                                <Typography
                                    variant="h5"
                                    gutterBottom
                                    className="login-title forgot-title"
                                >
                                    Resetowanie hasla
                                </Typography>

                                <Grid item xs={12}>
                                    {validationMessage && (
                                        <div className="validation-error-green">
                                            Link do resetu hasla zostal wyslany
                                            na wskazany adres email
                                        </div>
                                    )}
                                </Grid>

                                <TextField
                                    label="Email"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    value={email}
                                    onChange={handleEmailChange}
                                    required
                                    autoComplete="off"
                                />

                                <Button
                                    type="submit"
                                    variant="contained"
                                    fullWidth
                                    size="large"
                                    className="buttonFilled forgot-submit"
                                >
                                    {isLoading && <span className="loader"></span>}
                                    {!isLoading && <span>Resetuj</span>}
                                </Button>
                            </form>
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </div>
    );
};

export default ForgotComponent;
